import { render, staticRenderFns } from "./PagoTasas.vue?vue&type=template&id=5873f944&"
import script from "./PagoTasas.vue?vue&type=script&lang=js&"
export * from "./PagoTasas.vue?vue&type=script&lang=js&"
import style0 from "./PagoTasas.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports